import React, { createContext, useContext } from 'react';
import { EmoteBurst, useEmoteChannel, DEFAULT_EMOTE_SLOTS, EMOTE_PICKER_OPTIONS } from './hooks/useEmoteChannel';

// Lekki kontekst do emotek: kapsułkuje kanał online + sloty pickerów,
// eksponując stabilny fallback dla środowisk bez providera (np. testy).

interface EmoteContextValue {
  slots: string[];
  setSlotEmoji: (index: number, emoji: string) => void;
  sendEmote: (index: number) => void;
  bursts: EmoteBurst[];
  options: string[];
}

const fallbackValue: EmoteContextValue = {
  slots: [...DEFAULT_EMOTE_SLOTS],
  setSlotEmoji: () => {},
  sendEmote: () => {},
  bursts: [],
  options: EMOTE_PICKER_OPTIONS,
};

const EmoteContext = createContext<EmoteContextValue>(fallbackValue);

interface ProviderProps {
  children: React.ReactNode;
  gameId?: string;
  playerId?: string | null;
  playerName?: string | null;
  enabled?: boolean;
}

export function EmoteProvider({ children, gameId, playerId, playerName, enabled = true }: ProviderProps) {
  const value = useEmoteChannel({ gameId, playerId, playerName, enabled });
  return (
    <EmoteContext.Provider value={value}>
      {children}
    </EmoteContext.Provider>
  );
}

export function useEmotes() {
  return useContext(EmoteContext);
}

export type { EmoteBurst };
